import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen bg-[#040D1A] flex items-center justify-center">
        <div
          data-testid="admin-loading"
          className="w-10 h-10 border-2 border-amber-400 border-t-transparent rounded-full animate-spin"
        />
      </div>
    );
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
